import { NavLinkType } from "../../../types";
export const navLinks: NavLinkType[] = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Properties",
    link: "/properties",
  },
  {
    name: "About Us",
    link: "/about",
  },
  {
    name: "Blogs",
    link: "/announcements",
  },
  {
    name: "Contact",
    link: "/contact",
  },
];

export const mockProperties = {
  forRent: [],
  forSale: [],
  forShortlet: [],
};

export const FOOTER_NAV_LINKS = [
  {
    name: "Property For Rent",
    url: "/properties/rent",
  },
  {
    name: "Property For Short Let",
    url: "/properties/shortlet",
  },
  {
    name: "Property For Outright Sales",
    url: "/properties/sale",
  },
  {
    name: "Property For Installment Sales",
    url: "/properties/sale",
  },
];

export const PAGES_LINKS = [
  {
    name: "Branch & Staff",
    url: "/branches",
  },
  {
    name: "Announcement",
    url: "/announcements",
  },
  {
    name: "About Us & Reviews",
    url: "/about",
  },
  {
    name: "Services & Contact Page",
    url: "/contact",
  },
];
